import { Storage } from "./storage";

class LocalStorage extends Storage {
    constructor() {
        super("localStorage");
    }
}

const localStorage = new LocalStorage();

export default localStorage;